import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { useI18n } from "../../i18n";
import { EASE } from "../../lib/site";
import { Reveal, SectionLabel } from "./Reveal";

const PHOTOS = [
  { src: "/img/tv1.jpg", r: "palestine" },
  { src: "/img/tv2.jpg", r: "palestine" },
  { src: "/img/tv4.jpg", r: "israel" },
  { src: "/img/tv3.jpg", r: "europe" },
  { src: "/img/tv5.jpg", r: "europe" },
  { src: "/img/tv6.jpg", r: "europe" },
];

const Counter = ({ to }) => {
  const [n, setN] = useState(to);
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.5 });
  useEffect(() => {
    if (!inView) return undefined;
    let i = 0;
    setN(0);
    const id = setInterval(() => { i += 1; setN(i); if (i >= to) clearInterval(id); }, 60);
    return () => clearInterval(id);
  }, [inView, to]);
  return <span ref={ref}>{n}</span>;
};

export const Travel = () => {
  const { t } = useI18n();
  const tr = t.travel;
  return (
    <div className="py-6">
      <Reveal><SectionLabel>{tr.label}</SectionLabel></Reveal>
      <div className="mt-6 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-8">
          <Reveal delay={0.1}><h2 className="font-serif text-4xl leading-[1.05] text-ink sm:text-5xl">{tr.title}</h2></Reveal>
          <Reveal delay={0.15}><p className="mt-4 max-w-xl text-base leading-relaxed text-body-ink">{tr.body}</p></Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-4 lg:text-right">
          <div data-testid="travel-country-count" className="font-serif text-7xl leading-none text-terra sm:text-8xl"><Counter to={17} />+</div>
          <div className="mt-2 font-mono text-xs uppercase tracking-[0.28em] text-muted-ink">{tr.count}</div>
        </Reveal>
      </div>
      <div className="mt-10 columns-2 gap-4 md:columns-3">
        {PHOTOS.map((p, i) => (
          <motion.figure
            key={p.src}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, ease: EASE, delay: (i % 3) * 0.08 }}
            data-testid={`travel-photo-${i}`}
            className="group relative mb-4 break-inside-avoid overflow-hidden rounded-2xl"
          >
            <img src={p.src} alt={`${tr[p.r]} - travel photo ${i + 1}`} loading="lazy" className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]" />
            <figcaption className="absolute bottom-3 left-3 rounded-full bg-ink/70 px-3 py-1 text-xs text-paper backdrop-blur">{tr[p.r]}</figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  );
};
